import { Currency } from '@/core/currency/interfaces';
import {
    AFRICA_CURRENCIES,
    ASIA_CURRENCIES,
    EUROPE_CURRENCIES,
    MIDDLE_EAST_CURRENCIES,
    AMERICA_CURRENCIES,
    OCEANIA_CURRENCIES
} from '@/core/currency/constants/region';
import * as CurrencyUtils from './currency';

export const CURRENCIES: {[key: string]: Currency} = {
    ...AFRICA_CURRENCIES,
    ...ASIA_CURRENCIES,
    ...EUROPE_CURRENCIES,
    ...MIDDLE_EAST_CURRENCIES,
    ...AMERICA_CURRENCIES,
    ...OCEANIA_CURRENCIES
};

export default CurrencyUtils;
